import React from 'react';

import Descriptions from '../styled/Descriptions';
import Host from '../styled/Host';
import Paragraph1 from '../styled/Paragraph1';
import Wrapper from '../styled/Wrapper';

const NoWebGl = () => {
  return (
    <Host>
      <Wrapper>
        <Descriptions>
          <Paragraph1>No WebGl</Paragraph1>
        </Descriptions>
      </Wrapper>
    </Host>
  );
};

export default NoWebGl;
